import { render } from "./MoonGlobalParameterValue.vue?vue&type=template&id=69a96ed9&ts=true"
import script from "./MoonGlobalParameterValue.vue?vue&type=script&lang=ts"
export * from "./MoonGlobalParameterValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__